import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import dayjs, { type Dayjs } from 'dayjs';

interface FilterState {
  fromDate: Dayjs;
  toDate: Dayjs;
  /** ID of the company we last auto-snapped the date range for. App.tsx
   * uses this to avoid re-snapping every render when the user has already
   * explicitly chosen a range for the active company. */
  companyAnchor: string | null;
  setDateRange: (from: Dayjs, to: Dayjs) => void;
  setCompanyAnchor: (companyId: string | null) => void;
  resetDateRange: () => void;
}

export const useFilterStore = create<FilterState>()(
  persist(
    (set) => ({
      fromDate: dayjs().startOf('year'),
      toDate: dayjs().endOf('year'),
      companyAnchor: null,
      setDateRange: (from, to) => set({ fromDate: from, toDate: to }),
      setCompanyAnchor: (companyId) => set({ companyAnchor: companyId }),
      resetDateRange: () => set({ fromDate: dayjs().startOf('year'), toDate: dayjs().endOf('year') }),
    }),
    {
      name: 'hash_filters',
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          const parsed = JSON.parse(str);
          if (parsed?.state) {
            if (parsed.state.fromDate) parsed.state.fromDate = dayjs(parsed.state.fromDate);
            if (parsed.state.toDate) parsed.state.toDate = dayjs(parsed.state.toDate);
          }
          return parsed;
        },
        setItem: (name, value) => {
          const toStore = {
            ...value,
            state: {
              ...value.state,
              fromDate: value.state.fromDate?.format('YYYY-MM-DD'),
              toDate: value.state.toDate?.format('YYYY-MM-DD'),
            },
          };
          localStorage.setItem(name, JSON.stringify(toStore));
        },
        removeItem: (name) => localStorage.removeItem(name),
      },
    },
  ),
);
